export class SessionStaffing {
    constructor(
        public id: number,
        public title: string,
        public estimationDate: string,
        public message: string,
        public creationDate: Date,
        public archived: boolean
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/staffing/staffing.model.ts